export default __webpack_public_path__ + "static/media/pic13-1.10f90f2d.jpg";